module.exports = __webpack_public_path__ + "static/media/tut-1.f43f9bbc.png";